import { Link } from 'expo-router';
import { memo, useMemo } from 'react';
import { Platform, StyleSheet, View } from 'react-native';

import { IconStore, Text, tokens } from '@fhs/ui';
import { useStoreContext } from '@fhs-legacy/frontend/src/state/store';
import { CHECKOUT_STORE_SECTION } from '@fhs-legacy/frontend/src/utils/test-ids';

function StoreSection() {
  const { store } = useStoreContext();

  const addressLine = useMemo(
    () =>
      [
        store?.physicalAddress?.address1,
        store?.physicalAddress?.city,
        store?.physicalAddress?.stateProvince,
      ]
        .filter(Boolean)
        .join(', '),
    [
      store?.physicalAddress?.address1,
      store?.physicalAddress?.city,
      store?.physicalAddress?.stateProvince,
    ]
  );

  const isWeb = Platform.OS === 'web';

  return (
    <View
      testID={CHECKOUT_STORE_SECTION}
      style={styles.storeSection}
      {...(isWeb ? ({ tabIndex: 0 } as const) : {})}
    >
      <View
        style={styles.storeIcon}
        accessibilityElementsHidden
        importantForAccessibility="no-hide-descendants"
        {...(Platform.OS === 'web' ? { 'aria-hidden': true } : {})}
      >
        <IconStore size={24} />
      </View>
      <View style={{ flex: 1 }}>
        <Text.Ui size="xs">Pick up at:</Text.Ui>
        <Text.Heading numberOfLines={2} type="three">
          {store.name}
        </Text.Heading>
        <Text.Ui numberOfLines={2} size="sm">
          {addressLine}
        </Text.Ui>
      </View>
      <View>
        <Link href="/store-locator?back=/cart/payment" asChild>
          <Text.Ui
            style={styles.changeStoreLink}
            size="sm"
            accessibilityLabel="Change pickup store"
          >
            Change
          </Text.Ui>
        </Link>
      </View>
    </View>
  );
}

export default memo(StoreSection);

const styles = StyleSheet.create({
  storeSection: {
    width: '100%',
    gap: 8,
    padding: 16,
    flexDirection: 'row',
    alignItems: 'center',
    paddingBottom: 0,
    marginBottom: 20,
  },

  changeStoreLink: {
    textDecorationLine: 'underline',
    color: tokens.colors.$houseDark,
  },

  storeIcon: {
    alignSelf: 'flex-start',
    marginTop: 4,
  },
});
